import React from "react"
import { Link } from "gatsby"
import { format } from "date-fns"
import { FaLongArrowAltRight } from "react-icons/fa"
import OptimizedImage from "gatsby-image/withIEPolyfill"

/**
 * Single Post Component
 * This component is used to Generate a single post element
 * this component should not execute any graphql query
 * unless the query data is used in all the posts
 *
 * @param {Object} props
 */
const PostSingle = ({ post }) => {
  const {
    slug,
    mainImage,
    title,
    publishedAt,
    author,
    categories,
    excerpt,
  } = post

  return (
    <div className="post-single">
      <div className="post-single__image">
        <Link className="post-single__image-inner" to={`/${slug.current}/`}>
          <OptimizedImage
            fluid={mainImage.asset.fluid}
            alt={title}
            fadeIn={true}
            objectFit="contain"
            objectPosition="50% 50%"
          />
        </Link>
      </div>
      <div className="post-single__content">
        <div className="post-single__date">
          <span>{format(publishedAt, "DD")}</span>
          {format(publishedAt, "MMM")}
        </div>
        <div className="post-single__meta">
          {author && <p>{author.name}</p>}
          {categories &&
            categories.map((category, index) => (
              <p key={index}>{category.title}</p>
            ))}
        </div>
        <Link className="post-single__title" to={`/${slug.current}/`}>
          {title}
        </Link>
        <p className="post-single__text">{excerpt}</p>
        <div className="post-single__bottom">
          <Link className="post-single__link" to={`/${slug.current}/`}>
            <span>More Details</span> <FaLongArrowAltRight />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PostSingle
